import PropTypes from 'prop-types';
import {css} from 'styled-components';
import {map} from '../../breakpoint';
import {Nullable, ResponsiveOrStaticProp} from './../../utils';
import {colorValues, pickColor} from './colors';
import {DimensionsType} from './dimensions';

const validBorderStyleValues = ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'inset', 'ridge', 'outset'] as const;
export type borderStyleValues = (typeof validBorderStyleValues)[number];

export type BorderStyleType = ResponsiveOrStaticProp<Nullable<borderStyleValues>>;

export type BorderType = ResponsiveOrStaticProp<string>;

export const border = (props: any) => css`
  ${({borderColor}: {borderColor: colorValues}) =>
    map(
      borderColor,
      (color: colorValues) =>
        color &&
        css`
          border-color: ${pickColor(color)};
        `
    )};

  ${({borderWidth}: any) =>
    map(
      borderWidth,
      (val: DimensionsType) =>
        val !== undefined &&
        css`
          border-width: ${val};
        `
    )};

  ${({borderStyle}: any) =>
    map(
      borderStyle,
      (val: borderStyleValues) =>
        val &&
        css`
          border-style: ${val};
        `
    )};
`;

export const borderStylePropType = PropTypes.oneOf(validBorderStyleValues);

export const borderStylePropTypeMap = PropTypes.oneOfType([
  borderStylePropType,
  PropTypes.shape({
    xs: borderStylePropType,
    sm: borderStylePropType,
    md: borderStylePropType,
    lg: borderStylePropType,
    xl: borderStylePropType,
    xxl: borderStylePropType,
    xxxl: borderStylePropType
  })
]);
